import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { IdsRedirectPage } from '~/components/ids/IdsRedirectPage';

const validateSearch = z.object({
  action: z.string().optional(),
  company_id: z.string().optional(),
  token: z.string().optional(),
});

export const Route = createFileRoute('/ids-redirect')({
  component: IdsRedirectPage,
  validateSearch,
});
